"use client";

import { useId } from "react";

/**
 * 封蝋。まだ受け取っていない贈り物・受け取れる報酬の印に押す。
 * ふちの不揃いな赤い蝋に、内側の輪と図書館の ∞ の印を浮き出させる
 */
export default function WaxSeal({
  size = 44,
  rotate = 0,
  label,
  className = "",
}: {
  /** 直径（px） */
  size?: number;
  rotate?: number;
  /** 読み上げの名前（無ければ読み上げない） */
  label?: string;
  className?: string;
}) {
  const id = useId().replace(/:/g, "");
  return (
    <span
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}
      className={`inline-block shrink-0 ${className}`}
      style={{ width: size, height: size, transform: rotate ? `rotate(${rotate}deg)` : undefined }}
    >
      <svg viewBox="0 0 100 100" width={size} height={size} className="block overflow-visible" aria-hidden="true">
        <defs>
          <radialGradient id={`wax-${id}`} cx="38%" cy="32%" r="75%">
            <stop offset="0" stopColor="#d9534a" />
            <stop offset=".55" stopColor="#a8282a" />
            <stop offset="1" stopColor="#6e1418" />
          </radialGradient>
          <filter id={`wax-shadow-${id}`} x="-20%" y="-20%" width="140%" height="150%">
            <feDropShadow dx="0" dy="2.5" stdDeviation="2.5" floodColor="#000" floodOpacity=".55" />
          </filter>
        </defs>
        {/* 蝋のふち（押して広がった不揃いな丸） */}
        <path
          d="M50 4c7 0 9 4 15 5s11-1 15 4 2 9 5 14 8 7 8 14-4 9-4 15 3 10-1 15-9 4-13 8-6 9-13 10-9-4-15-4-10 4-15 1-4-9-9-12-10-3-13-9 1-10 0-16-6-9-3-15 8-6 11-11 1-10 6-13 9 1 14-2 8-6 15-6z"
          fill={`url(#wax-${id})`}
          filter={`url(#wax-shadow-${id})`}
        />
        {/* 押し型の輪 */}
        <circle cx="50" cy="50" r="30" fill="none" stroke="#5e1014" strokeWidth="3" opacity=".7" />
        <circle cx="50" cy="50" r="30" fill="none" stroke="#f08a7e" strokeWidth="1" opacity=".45" transform="translate(-.8 -.8)" />
        {/* 図書館の ∞（浮き出し: 下に影、上に光） */}
        <path d="M50 50C46 42 33 41 33 50C33 59 46 58 50 50C54 42 67 41 67 50C67 59 54 58 50 50Z" fill="none" stroke="#5e1014" strokeWidth="4.5" strokeLinejoin="round" transform="translate(0 1.5)" opacity=".75" />
        <path d="M50 50C46 42 33 41 33 50C33 59 46 58 50 50C54 42 67 41 67 50C67 59 54 58 50 50Z" fill="none" stroke="#e8776c" strokeWidth="3" strokeLinejoin="round" opacity=".9" />
      </svg>
    </span>
  );
}
